import {
  Component,
  OnInit,
  Optional,
  Inject,
  SecurityContext,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { map, takeUntil } from 'rxjs/operators';
import { MessageService } from '../../../common/services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { Router } from '@angular/router';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from 'src/app/common/services/formater.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { PusherEventService } from 'src/app/common/services/pusher-event.service';
import { Subject, Subscription } from 'rxjs';
import { Event as EventList, MType as MtypeList } from 'src/app/pusher-event';
import { CROSS, PRINT, DUIT_NOW } from 'src/defaultImages.js';
import { QRCodeService } from 'src/app/common/services/qr-code.service';
import { PAYMENT_CHANNEL_ID, PaymentMethod } from 'src/app/common/enums/payment';
import { PaymentService } from 'src/app/common/services/payment.service';
import { PineLabService } from 'src/app/common/services/pine-lab.service';
import { PineLabDefaultChannel, PineLabPmtChannels, PineLabsConsts, PineLabsEnum, PineLabsTimeOut } from 'src/app/common/enums/pinelabs.enum';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { SyncService, OrderSyncFetchSuppressMode, MergeBillOrderSyncEntry } from 'src/app/common/services/sync-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingCountersDataService } from 'src/app/common/services/billing-counters-data.service';
import { set } from 'date-fns';
declare function send_data(params: string): any;
declare global {
  interface Window {
    chrome: any;
  }
}

let chrome = window.chrome;
@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
  images = { 
    CROSS: CROSS,
    PRINT: PRINT,
    DUIT_NOW: DUIT_NOW
  };
  private ngUnsubscribe = new Subject();
  Currency;
  token: any;
  items = [];
  isKiosk;
  amount: any = {};
  details: any = {};
  paidAmount: number;
  showCashColleted: boolean;
  recommendationArray = [];
  billBalance: any;
  amountToReturn: any;
  balanceStatus: boolean = false;
  currentPaymentMode: string;
  currentPaymentChannel: string;
  transcation_id: string;
  ongoingRequest = 0;
  printData: any;
  panelOpenState = false;
  orderid: string;
  order_ids: any = [];
  allDataList: any = [];
  grandTotal: number = 0;
  openedFrom: string;
  mergedOrderIds: any = [];
  childOrderIds: string[] = [];
  kioskPrintOrderIds: string[] = [];
  kioskMergeCase: boolean = false;
  rest_id: string;
  cashCollectedDetails: any = {};
  splitBillData: any = {};
  cashData: any;
  translationText;
  isLoading: boolean = false;
  acknowledgeStatus: boolean = false;
  onlinePaymentModal: NzModalRef;;
  pusherForOnlinePaymentInitiated: boolean = false;
  qrData: string = ''

  pineLabModal:any;
  pmtStatusModal:any;
  pusherForPineLabInitiated: boolean = false;
  isPaymentAmtInputDisabledForOfflineMethods: boolean =false;
  isPLPmtLoading:boolean=false;
  printDelay: number;
  billingCounterName:string = '';
  billingCounterInfo: string = '';
  canTriggerKioskPrint:boolean = true;
  kioskPrintTimeout: ReturnType<typeof setTimeout>;
  private isMergeBillFetchSuppressEnabled = false;
  private isSplitBillFetchSuppressEnabled = false;
  private mergedOrderSyncEntries = new Map<string, MergeBillOrderSyncEntry>();
  subscription: Subscription = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<OrderDetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private message: MessageService,
    private utilService: UtilService,
    private _eventTracker: EventTrackerService,
    private _router: Router,
    private curr: CurrencyService,
    public translateService: TranslateService,
    public format: FormaterService,
    private _modalService: NzModalService,
    private _pusherEvent: PusherEventService,
    private _qrCodeService: QRCodeService,
    private _paymentService: PaymentService,
    private _pineLabService: PineLabService,
    private _localStorage: LocalStorageService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService,
    private _syncService: SyncService
  ) {
    this.Currency = this.curr.getCurrency();
    this.isKiosk = this.utilService.isKiosk();
    this.orderid = data.order_id;
    this.order_ids = data.order_ids;
    this.openedFrom = data.opened;
    this.isPaymentAmtInputDisabledForOfflineMethods =  ['splitbill', 'orderstab','tables-layout'].includes(this.openedFrom);
    this.splitBillData = data.cartData;
    this.printDelay = this.utilService.getPrintDelay();
    this.translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD;
    });         
  }
  getAllCashStats() {
    const restId = localStorage.getItem('restaurant_id');
    const deviceId =  this.utilService.getDeviceUID();
    this.apiService.getCashRegisterAnalytics(restId, deviceId).subscribe((response) => {
      if (response.statusCode == 200) {
        this.cashData = response.data;
      }
    });
  }
  ngOnInit() {
    this.rest_id = localStorage.getItem('restaurant_id');
    this.token = localStorage.getItem('token');
    if (this.openedFrom !== 'splitbill') {
      if (this.order_ids && this.order_ids.length < 1) {
        this.get_selected_order_detail(this.data.order_id, 0);
      } else {
        this.mergedOrderIds.push(this.orderid);
        (this.order_ids || []).length &&
          this.order_ids.forEach((x) => this.mergedOrderIds.push(x));
        this._syncService.enableFetchSuppressMode(
          OrderSyncFetchSuppressMode.MERGE_BILL
        );
        this.isMergeBillFetchSuppressEnabled = true;
        this.mergedOrderIds.forEach((x, i) =>
          this.get_selected_order_detail(x, i)
        );
      }
      if(this.isKiosk && this.mergedOrderIds?.length > 1){
        this.kioskMergeCase = true;
        this.getMergedKioskOrderDetails();
      }
    } else if (this.openedFrom === 'splitbill') {
      this.items = this.splitBillData.items;
      this.amount = this.splitBillData.bill.fees;
      this.details = {
        name:
          this.splitBillData.guest_name ||
          `${this.translationText.GUEST} ${this.data.index + 1}`,
        ordercount: this.items.length,
        orderno: this.data.order_no,
        balance: this.splitBillData.bill.balance,
        balance_text: this.splitBillData.bill.balance_text,
        billtotal: this.splitBillData.bill.bill_total,
        paid: this.splitBillData.bill.paid,
      };
      this.grandTotal += +this.splitBillData?.bill?.balance || 0;
      let group = {
        items: this.items,
        amount: this.amount,
        details: this.details,
      };
      this.allDataList.push(group);
      this._syncService.enableFetchSuppressMode(
        OrderSyncFetchSuppressMode.SPLIT_BILL
      );
      this.isSplitBillFetchSuppressEnabled = true;
      if (Array.isArray(this.data?.allGuestData) && this.data.allGuestData.length) {
        this._syncService.setSplitBillContext(
          this.data.order_id || this.orderid,
          this.data.allGuestData
        );
      }
      this.triggerSplitBillPaymentInitiateSync();
    }
    if (this.utilService.cashRegistryEnabled()) {
      this.getAllCashStats();
    }
    this.getBillingCounterName();
  }

  ngOnDestroy(): void {
    if (this.isMergeBillFetchSuppressEnabled) {
      this._syncService.disableFetchSuppressMode(
        OrderSyncFetchSuppressMode.MERGE_BILL
      );
    }
    if (this.isSplitBillFetchSuppressEnabled) {
      this._syncService.disableFetchSuppressMode(
        OrderSyncFetchSuppressMode.SPLIT_BILL
      );
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    clearTimeout(this.kioskPrintTimeout);
  }

  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
          if (this.billingCounterName) {
            this.setSubHeading('PAYMENT_RECORDED');
          }
        })
    );

  }
  closeDialog() {
    this.dialogRef.close({
      event: 'close',
      api: false,
      ack: this.acknowledgeStatus,
    });
  }

  private tryTriggerMergeBillSync(): void {
    if (!this.isMergeBillFetchSuppressEnabled || !this.mergedOrderIds?.length) {
      return;
    }
    if (this.mergedOrderIds.length < 2) {
      return;
    }
    const merged_orders = this.mergedOrderIds
      .map((id) => this.mergedOrderSyncEntries.get(String(id)))
      .filter((entry): entry is MergeBillOrderSyncEntry => !!entry);
    if (merged_orders.length !== this.mergedOrderIds.length) {
      return;
    }
    const restaurantId = this.rest_id || this._localStorage.get('restaurant_id');
    const primaryOrderId = this.mergedOrderIds[0];
    if (!restaurantId || !primaryOrderId) {
      return;
    }
    this._syncService
      .syncMergeBillState(restaurantId, primaryOrderId, merged_orders)
      .subscribe(() => {}, () => {});
  }

  private buildMergeBillSyncEntry(
    orderid: string,
    data: any
  ): MergeBillOrderSyncEntry {
    return {
      order_id: String(orderid),
      order_details: data,
    };
  }

  private clearMergedOrderSyncEntries(): void {
    this.mergedOrderSyncEntries.clear();
  }

  private getMergedOrdersForSync(): MergeBillOrderSyncEntry[] {
    if (!this.isMergeBillFetchSuppressEnabled || !this.mergedOrderIds?.length) {
      return [];
    }
    return this.mergedOrderIds
      .map((id) => this.mergedOrderSyncEntries.get(String(id)))
      .filter((entry): entry is MergeBillOrderSyncEntry => !!entry);
  }

  private triggerSplitBillPaymentInitiateSync(paymentResponse?: any): void {
    const restaurantId = this.rest_id || this._localStorage.get('restaurant_id');
    const orderId = this.data?.order_id || this.orderid;
    if (!restaurantId || !orderId) {
      return;
    }
    const guests = this.data?.allGuestData;
    const selectedGuestEntry = this._syncService.buildOrderSplitFromGuests(
      this.splitBillData ? [this.splitBillData] : []
    )[0];
    const publishSync = (orderDetails?: any, orderSplitGuests?: any[]) => {
      const order_split = this._syncService.buildOrderSplitFromGuests(
        orderSplitGuests || []
      );
      const data: {
        payment_response?: any;
        order_details?: any;
        order_split?: ReturnType<SyncService['buildOrderSplitFromGuests']>;
        selected_guest?: ReturnType<SyncService['buildOrderSplitFromGuests']>[0];
      } = {};
      if (paymentResponse) {
        data.payment_response = paymentResponse;
      }
      if (orderDetails) {
        data.order_details = orderDetails;
      }
      if (order_split.length) {
        data.order_split = order_split;
      }
      if (selectedGuestEntry) {
        data.selected_guest = selectedGuestEntry;
      }
      this._syncService
        .syncPaymentInitiateState(restaurantId, orderId, data)
        .subscribe(() => {}, () => {});
    };
    const syncWithGuests = (orderDetails?: any, orderSplitGuests?: any[]) => {
      publishSync(orderDetails, orderSplitGuests);
    };
    this.apiService.getOrderDetailsNest(orderId).subscribe((orderRes) => {
      const orderDetails =
        Number(orderRes?.statusCode) === 200 ? orderRes?.data : undefined;
      if (Array.isArray(guests) && guests.length) {
        syncWithGuests(orderDetails, guests);
        return;
      }
      this.apiService.getSplitBillDetails(orderId).subscribe((guestsRes) => {
        const orderSplitGuests =
          Number(guestsRes?.statusCode) === 200 && Array.isArray(guestsRes?.data)
            ? guestsRes.data
            : [];
        syncWithGuests(orderDetails, orderSplitGuests);
      });
    });
  }

  private triggerPaymentInitiateSync(paymentResponse: any): void {
    const restaurantId = this.rest_id || this._localStorage.get('restaurant_id');
    const primaryOrderId = this.mergedOrderIds[0] || this.orderid;
    if (!restaurantId || !primaryOrderId || !paymentResponse) {
      return;
    }
    const merged_orders = this.getMergedOrdersForSync();
    const data: {
      payment_response: any;
      merged_orders?: MergeBillOrderSyncEntry[];
    } = { payment_response: paymentResponse };
    if (
      merged_orders.length >= 2 &&
      merged_orders.length === this.mergedOrderIds.length
    ) {
      data.merged_orders = merged_orders;
    }
    this._syncService
      .syncPaymentInitiateState(restaurantId, primaryOrderId, data)
      .subscribe(() => {}, () => {});
  }

  private triggerPaymentCompletedSync(): void {
    if (
      !this.isMergeBillFetchSuppressEnabled ||
      !this.mergedOrderIds?.length ||
      this.mergedOrderIds.length < 2
    ) {
      return;
    }
    const restaurantId = this.rest_id || this._localStorage.get('restaurant_id');
    const primaryOrderId = this.mergedOrderIds[0];
    if (!restaurantId || !primaryOrderId) {
      return;
    }
    const merged_orders = this.getMergedOrdersForSync();
    const data: { merged_orders?: MergeBillOrderSyncEntry[] } = {};
    if (merged_orders.length === this.mergedOrderIds.length) {
      data.merged_orders = merged_orders;
    }
    this._syncService
      .syncPaymentCompletedState(restaurantId, primaryOrderId, data)
      .subscribe(() => {}, () => {});
  }

  watchPusherEvents() {
    /*Watching order  events on pusher*/
    this._pusherEvent
      .watchEvent(EventList.ORDER_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onNewPusherEvent(event));
  }

  onNewPusherEvent(message) {
    if (message.mtype === MtypeList.PAYMENT_SUCCESS) {
      const requiredStatus = [3, 4];
      this.apiService
        .getOrderDetailsNest(message.data.order_id)
        .subscribe((response: any) => {
          if (requiredStatus.includes(response.data.payment_status)) {
            if (this.onlinePaymentModal) {
              this.onlinePaymentModal.destroy({ data: 'success' });
            } else if(this.pineLabModal){
              const paymentsData = ((response.data || {}).bill || {}).payments || [];
              const paymentMethod = (Array.isArray(paymentsData) && paymentsData.length ) ? (paymentsData[paymentsData.length-1] || {}).payment_method :'';   
              this.pineLabModal.destroy({ data: PineLabsEnum.PAYMENT_SUCCESS ,paymentMethod:paymentMethod});
            }
             else {
              if(!PineLabPmtChannels.includes(((message || {}).data || {}).payment_channel_pusher)){
                this.message.showSuccess(this.translationText.PAYMENT_SUCCESSFUL);
              }
              this.grandTotal = 0;
            }
          }
        });
    }
    if (message.mtype === MtypeList.PAYMENT_FAILED) {
      this.message.showError(this.translationText.PAYMENT_FAILED);
    }
  }

  async initiateOnlinePayment(payment_method:string, callback: any) {
    const orderId = this.orderid
    const mergedOrderIds = this.mergedOrderIds.filter((id) => id !== this.orderid) || []
    const params = this.utilService.getOnlinePaymentParams({paymentMethod: payment_method, orderId: orderId, mergedOrderIds: mergedOrderIds});
    try {
      const result = await this._paymentService.initiateOnlinePayment(params);
      if (result) {
        if (this.openedFrom === 'splitbill') {
          this.triggerSplitBillPaymentInitiateSync(result.paymentData);
        } else {
          this.triggerPaymentInitiateSync(result.paymentData);
        }
        callback.call(this, result.paymentData);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async initiateKioskOnlinePayment(payment_method: string, callback: any) {
    const orderId = this.orderid;
    const params = this.utilService.getOnlinePaymentParams({
      paymentMethod: payment_method,
      orderId: orderId,
      isFcUnpaidOrder: true,
      childOrderIds: this.childOrderIds,
      fcOrderIds: this.mergedOrderIds,
    });
    try {
      const result = await this._paymentService.initiateKioskOnlinePayment(params);
      if (result) {
        this.triggerPaymentInitiateSync(result.paymentData);
        callback.call(this, result.paymentData);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Helper function to handle payment initiation based on kiosk mode
  private initiatePayment(paymentMethod: string, callback: any): void {
    if (this.isKiosk) {
      this.initiateKioskOnlinePayment(paymentMethod, callback);
    } else {
      this.initiateOnlinePayment(paymentMethod, callback);
    }
  }

  regenerateQR() {
    this.qrData = ''
    this._qrCodeService.updateQRData(this.qrData);
    this.initiatePayment(PaymentMethod.duitnow, this.regenerateQRCallback);
  }

  openQRPage() {
    this.initiatePayment(PaymentMethod.duitnow, this.duitnowCallback);
  }

  openIframe() {
    this.initiatePayment(PaymentMethod.doku_qris, this.qrisCallback);
  }

  regenerateQRCallback(res: any) {
    this.qrData = res.data.qr_data;
    // Update the QR code in the QRCodeService
    this._qrCodeService.updateQRData(this.qrData);
  }

  async duitnowCallback(res: any) {
    this.qrData = res.data.qr_data;
    this._qrCodeService.updateQRData(this.qrData);
    const { PaymentQRComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/pos-order/modals/payment-qr/payment-qr.component'
    );
    this.onlinePaymentModal = this._modalService.create({
      nzContent: PaymentQRComponent,
      nzTitle: `<div class="header-container"><img class="duit-now" src="${this.images.DUIT_NOW}" alt="Info" />
      <div class="sub-header">${this.translationText.QRIS_SUBHEADER}</div>
      </div>`,
      nzWrapClassName: 'ftue',
      nzBodyStyle: { "min-width": '65vw', width: 'auto', "max-width":"85vw", height: 'auto', 'max-height': '80vh', overflowY:'scroll' },
      nzFooter: null,
      nzClosable: false,
      nzComponentParams: {
        customCloseIcon: true,
        qrData: this.qrData,
        title: 'Duit now',
        regenerateQrHandler: this.regenerateQR.bind(this)
      },
    });
    this.modalServiceCallback();
  }

  async qrisCallback(res: any) {
    const { IframeComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/pos-order/modals/iframe/iframe.component'
    );
    this.onlinePaymentModal = this._modalService.create({
      nzContent: IframeComponent,
      nzTitle: `<div class="header-container">QRIS
      <div class="sub-header">${this.translationText.QRIS_SUBHEADER}</div>
      </div>`,
      nzWrapClassName: 'ftue',
      nzBodyStyle: { width: 'auto', height: 'auto' },
      nzFooter: null,
      nzComponentParams: {
        iframeSource: res.payment_page_url,
        title: 'QRIS',
      },
    });
    this.modalServiceCallback();
  }

  modalServiceCallback() {
    if (!this.pusherForOnlinePaymentInitiated) {
      this.watchPusherEvents();
      this.pusherForOnlinePaymentInitiated = true;
    }
    this.onlinePaymentModal.afterClose.subscribe((result: any = {}) => {
      this.onlinePaymentModal = null;
      if (result.data === 'success') {
        this.message.showSuccess(this.translationText.PAYMENT_SUCCESSFUL);
        this.allDataList = [];
        this.clearMergedOrderSyncEntries();
        this.mergedOrderIds?.forEach((x, i) =>
          this.get_selected_order_detail(x, i)
        );
        return (this.grandTotal = 0);
      }
      this.apiService
        .getOrderDetailsNest(this.orderid)
        .subscribe((response: any) => {
          const requiredStatus = [3, 4];
          if (requiredStatus.includes(response.payment_status)) {
            this.message.showSuccess(
              this.translationText.PAYMENT_SUCCESSFUL
            );
            this.grandTotal = 0;
          }
        });
    });
  }
  
  printBill() {
    if (this.isKiosk) {
      this.printKioskBill();
    } else {
      this.printFinalBill();
    }
  }

  async openPaymentStatusPopUp(pmtStatus,amount,paymentMethod){
    this.pmtStatusModal = await this._pineLabService.commonPaymentStatusModal(pmtStatus,amount,paymentMethod);
   this.pmtStatusModal.afterClose.subscribe(() => {
    this.pmtStatusModal = null;
    this.dialogRef.close({ data: '' });
  });
 }

    // Payment Initiated for PineLab
    initiatePLPayment(orderId): void {
      try {
        this.isPLPmtLoading = true;
        const mergedOrderIds = this.mergedOrderIds.filter((id) => id !== orderId) || [];
        const pineLabPayload = this.utilService.getOnlinePaymentParams({paymentMethod: PaymentMethod.PINE_LABS, orderId: orderId, mergedOrderIds: mergedOrderIds});
        this.apiService.initiatePLPayment(pineLabPayload).subscribe((res) => {
          this.isPLPmtLoading = false;
          if(res){
          if (res.data && res.data.pineLabsResponseCode==PineLabsConsts.SUCCESS) {
             this.openPineLabWaitingPopUp(orderId,res.data.pineLabsPtrId,res.data.invoice_number,res.data.amount,mergedOrderIds);
          } else if(res.meta || res.http){
              this.message.showError((res.meta || res.http).message);
          }
        }
        });
      } catch (error) { }
    }

    async openTimeOutPopup(amount){
     const timeOutModal = await this._pineLabService.commonTimeOutModal(amount);
     timeOutModal.afterClose.subscribe((result: any = {}) => {
         if(result==PineLabsTimeOut.RETRY){
         }else{
          this.dialogRef.close({ data: '' });
         }
    });
   } 
    // waiting Payment popup for PineLab 
   async openPineLabWaitingPopUp(orderId:string,ptrId:string,pmtId:string,amount:number,mergedOrderIds:Array<any>) {
      const mergedOrderArr = [];
      if(Array.isArray(mergedOrderIds)){
        for (const oid of mergedOrderIds) {
          const orderObj = (this.allDataList || []).find((elm)=>elm.orderid == oid);
          const orderObjAmount = ((orderObj || {}).details || {}).balance;
          mergedOrderArr.push({orderid:oid,amount:orderObjAmount});
        }
      }

      this.pineLabModal = await this._pineLabService.commonWaitingPaymentModal({
        orderId: orderId,
        ptrId:ptrId,
        pmtId:pmtId,
        amount:amount,
        mergedOrderArr:mergedOrderArr,
        isSettleBillCall:false,
        isMaxiMize:false
      });
      if (!this.pusherForPineLabInitiated) {
        this.watchPusherEvents();
        this.pusherForPineLabInitiated = true;
      }
      this.pineLabModal.afterClose.subscribe((result: any = {}) => {
        this.pineLabModal = null;
        if (result.data === PineLabsEnum.PAYMENT_SUCCESS) {
          this.openPaymentStatusPopUp(PineLabsEnum.PAYMENT_SUCCESS,amount,result.paymentMethod);
        }else if(result.data ===  PineLabsEnum.PAYMENT_FAILED){
          this.message.showError(result.data);
          this.openPaymentStatusPopUp(PineLabsEnum.PAYMENT_FAILED,amount,'');
        }else if(result.data == PineLabsEnum.PAYMENT_CANCELLED){
          this.message.showError(this.translationText.PAYMENT_CANCELED);
          this._pineLabService.removePLDataByOrderId(orderId,mergedOrderArr,false);
        }else if(result.data == PineLabsEnum.POP_UP_MINIMIZE){
          this.dialogRef.close({ data: '' });
        }else if(result.data == PineLabsTimeOut.EXPIRED){
          this.openTimeOutPopup(amount);
        }
      });
    }

    paymentDoneClicked() {
      if (this.currentPaymentChannel === 'cash') {
        this.openDrawerOnDevice();
      }
      if (
        this.utilService.cashRegistryEnabled() &&
        this.currentPaymentChannel == 'cash'
      ) {
        const currCollectedAmt = this.format.formatMy(this.cashCollectedDetails.collected_amt);
        if((currCollectedAmt < this.grandTotal) && this.isPaymentAmtInputDisabledForOfflineMethods) {
          this.message.showError(this.translationText.AMOUNT_ENTERED_CANT_BE_LESS_THAN_BILL);
        } else if (this.cashData['active-epoch'] != null) {
          this.mark_cash_collected(this.data.order_id);
        } else {
          this.message.showError(
            this.translationText
              .CASH_IS_CLOSED_TO_ACCEPT_CASH_OPEN_CASHIER_FIRST
          );
        }
      } else if (this.currentPaymentChannel === PAYMENT_CHANNEL_ID.QRIS_CHANNEL_ID) {
        this.openIframe();
      } else if (this.currentPaymentChannel === PAYMENT_CHANNEL_ID.DUITNOW_CHANNEL_ID) {
        this.openQRPage();
      } else if(this.currentPaymentChannel === PineLabDefaultChannel.PAYMENT_CHANNEL){
        if(!this.isPLPmtLoading){
          this.initiatePLPayment(this.orderid);
        }
      } else {
        this.mark_cash_collected(this.data.order_id);
      }
  }

  acknowledge_notification(message_id) {
    const formData: any = new FormData();
    formData.append('token', this.token);
    formData.append('message_id', message_id);
    this.apiService
      .acknowelgeTableNotification(formData)
      .pipe(map((res) => res))
      .subscribe((_res) => {
        this.closeDialog();
      });
  }
  createPayload(formData) {
    const object = {};
    formData.forEach((value, key) => {
      if (key === 'collected_amt') {
        object['collected_amount'] = +value;
      } else {
        object[key] = value;
      }
    });
    object['kiosk_restaurant_id'] = localStorage.getItem('restaurant_id');
    if(this.kioskMergeCase) {
      object['fc_order_ids'] = this.mergedOrderIds;
    }
    const json = JSON.stringify(object);
    return json;
  }

  kioskCashCollection(order_id) {
    this.ongoingRequest = 1;
    if (this.order_ids == undefined) {
      this.order_ids = [];
    }
    const formData: any = new FormData();
    formData.append('fc_order_id', order_id);
    formData.append('payment_channel', this.currentPaymentChannel);
    formData.append('transaction_id', this.transcation_id);
    if (this.openedFrom === 'orderstab' || this.openedFrom === 'tables-layout')
      formData.append('collected_by', 'mm');
    if (
      this.cashCollectedDetails &&
      this.cashCollectedDetails.collected_amt &&
      this.cashCollectedDetails.returned_amt
    ) {
      formData.append(
        'collected_amt',
        +this.format.formatMy(this.cashCollectedDetails.collected_amt)
      );
      formData.append(
        'returned_amt',
        +this.format.formatMy(this.cashCollectedDetails.returned_amt)
      );
    }
    if (this.openedFrom === 'splitbill') {
      formData.append('guest_id', this.splitBillData.guest_id);
    }
    if (
      this.isKiosk &&
      this.cashCollectedDetails &&
      this.cashCollectedDetails.collected_amt &&
      this.currentPaymentChannel === 'cash'
    ) {
      formData.append(
        'collected_amt',
        +this.format.formatMy(this.cashCollectedDetails.collected_amt)
      );
    }
    formData.append('device_id', this.utilService.getDeviceUID());
    const payload = this.createPayload(formData);
    this.apiService.cashCollectedKiosk(payload)
      .pipe((res) => res)
      .subscribe(
        (res: any) => {
          if (
            res?.status == 1 ||
            (res?.statusCode === 201 && res?.data?.status !== 0)
          ) {
            this.data?.mid && this.acknowledge_notification(this.data?.mid);
            this.message.showSuccess(
              res?.message ||
                this.translationText.PAYMENT_COLLECTED_SUCCESSFULLY
            );
            // close modal
            this.allDataList = [];
            this.grandTotal = 0;
            this.acknowledgeStatus = true;
            if (
              this.openedFrom !== 'splitbill' &&
              this.mergedOrderIds.length > 0
            ) {
              this.clearMergedOrderSyncEntries();
              this.mergedOrderIds.forEach((x, i) =>
                this.get_selected_order_detail(x, i)
              );
            } else if (this.openedFrom == 'splitbill') {
              this.dialogRef.close({ event: 'close', api: true, ack: true });
            }
            // Print final bill for each order incase of kiosk orders
            if (
              this.isKiosk &&
              this.details.kioskFcOrderIds.length &&
              this.utilService.isPrinterEnabled() &&
              !this.kioskMergeCase
            ) {
              try {
                if (this.canTriggerKioskPrint) {
                  this.canTriggerKioskPrint = false;
                  this.utilService.sendFinalPrintCommand(
                    this.data?.kioskFcOrderIds?.[0]
                  );
                  this.kioskPrintTimeout = setTimeout(() => {
                    this.canTriggerKioskPrint = true;
                  }, 3000);
                }
              } catch (error) {
                this.canTriggerKioskPrint = true;
                console.error(error);
              }
            }
          } else if (res?.status == 2) {
            this.message.showSuccess(
              this.translationText.ALREADY_COLLECTED_CASH
            );
            this.allDataList = [];
            this.grandTotal = 0;
            if (this.openedFrom !== 'splitbill') {
              this.clearMergedOrderSyncEntries();
              this.mergedOrderIds.forEach((x, i) =>
                this.get_selected_order_detail(x, i)
              );
            } else if (this.openedFrom == 'splitbill') {
              this.dialogRef.close({ event: 'close', api: false, ack: true });
            }
          } else {
            if (res?.data?.status === 0) {
              this.message.showError(res?.data?.message);
            } else {
              this.message.showError(res?.message);
            }
          }
          this.ongoingRequest = 0;
        },
        (error) => {
          this.ongoingRequest = 0;
          this.acknowledgeStatus = false;
          this.message.showError(
            error?.error?.message ||
              this.translationText.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER
          );
        }
      );
  }
  cashCollected(order_id) {
    this.ongoingRequest = 1;
    if (this.order_ids == undefined) {
      this.order_ids = [];
    }
    const payload = {
      orderId: order_id,
      orderIds: this.order_ids,
      paymentChannel: this.currentPaymentChannel,
      transactionId: this.transcation_id,
    };
    if (
      this.openedFrom === 'orderstab' ||
      this.openedFrom === 'tables-layout'
    ) {
      payload['collectedBy'] = 'mm';
    }
    if (
      this.cashCollectedDetails &&
      this.cashCollectedDetails.collected_amt &&
      this.cashCollectedDetails.returned_amt
    ) {
      payload['collectedAmt'] = +this.format.formatMy(
        this.cashCollectedDetails.collected_amt
      );
      payload['returnedAmt'] = +this.format.formatMy(
        this.cashCollectedDetails.returned_amt
      );
    }
    if (this.openedFrom === 'splitbill') {
      payload['guestId'] = this.splitBillData.guest_id;
    }
    payload['deviceId'] = this.utilService.getDeviceUID();
    this.apiService
      .cashCollectedNest(payload)
      .pipe((res) => res)
      .subscribe(
        (res) => {
          if (
            res?.data?.status === 1
          ) {
            this.data?.mid && this.acknowledge_notification(this.data?.mid);
            this.message.showSuccess(
              res?.data?.message || this.translationText.PAYMENT_COLLECTED_SUCCESSFULLY
            );
            this.triggerPaymentCompletedSync();
            // close modal
            this.allDataList = [];
            this.grandTotal = 0;
            this.acknowledgeStatus = true;
            if (
              this.openedFrom !== 'splitbill' &&
              this.mergedOrderIds.length > 0
            ) {
              this.clearMergedOrderSyncEntries();
              this.mergedOrderIds.forEach((x, i) =>
                this.get_selected_order_detail(x, i)
              );
            } else if (this.openedFrom == 'splitbill') {
              this.dialogRef.close({ event: 'close', api: true, ack: true });
            }
          } else if (res?.data?.status == 2) {
            this.message.showSuccess(
              this.translationText.ALREADY_COLLECTED_CASH
            );
            this.allDataList = [];
            this.grandTotal = 0;
            if (this.openedFrom !== 'splitbill') {
              this.clearMergedOrderSyncEntries();
              this.mergedOrderIds.forEach((x, i) =>
                this.get_selected_order_detail(x, i)
              );
            } else if (this.openedFrom == 'splitbill') {
              this.dialogRef.close({ event: 'close', api: false, ack: true });
            }
          } else {
              this.message.showError(res?.data?.message);
          }
          this.ongoingRequest = 0;
        },
        (error) => {
          this.ongoingRequest = 0;
          this.acknowledgeStatus = false;
          this.message.showError(
            error?.error?.message ||
              this.translationText.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER
          );
        }
      );
  }
  mark_cash_collected(order_id) {
    let id = this.isKiosk ? 'fc_order_id' : 'order_id';
    if (this.ongoingRequest == 1) {
      // this.message.info('collecting cash! please wait');
    } else {
      if (this.isKiosk) {
        this.kioskCashCollection(order_id);
      } else {
        this.cashCollected(order_id);
      }
    }
    this._eventTracker.easyeat_track_event('PAYMENT_SETTLED_POS', {
      BILL_TOTAL: this.grandTotal,
      MERGED_BILL:
        this.openedFrom === 'orderstab' || this.openedFrom === 'tables-layout'
          ? true
          : false,
      ORDER_ID: order_id,
      Payment_Method: this.currentPaymentChannel,
      TRANSACTION_ID: this.transcation_id,
    });
  }
  private processKioskOrderIds(orders: any[]): void {
    const kioskFcOrderIds = orders.map((order) =>
      order?.bill?.balance > 0 ? order?.order_id : []
    );
    this.childOrderIds = [...this.childOrderIds, ...kioskFcOrderIds];
    if (kioskFcOrderIds?.length > 0) {
      this.kioskPrintOrderIds = [...this.kioskPrintOrderIds, kioskFcOrderIds[0]];
    }
  }

  private getMergedKioskOrderDetails(): void {
    if (!this.kioskMergeCase || !this.mergedOrderIds?.length) return;
    this.mergedOrderIds.forEach(orderId => {
      this.apiService.getKioskOrderDetails(orderId)
        .subscribe((res) => {
          if (res?.data && res?.data?.orders) {
            this.processKioskOrderIds(res?.data?.orders);
          }
        });
    });
  }

  get_selected_order_detail(orderid, index) {
    const api = !this.isKiosk
      ? { function: () => this.apiService.getOrderDetailsNest(orderid) }
      : { function: () => this.apiService.getKioskOrderDetails(orderid) };
    this.isLoading = true;
    api
      .function()
      .pipe(map((res) => res.data))
      .subscribe((data) => {
        this.isLoading = false;
        if (this.isKiosk) {
          if(this.kioskMergeCase){
            this.items = [];
          }
          for (let order of data.orders) {
            this.items = [...this.items, ...order.items];
          }
          let name = data?.orders[0]?.name?.split(' ') || [''];
          this.details = {
            name: name[0],
            ordercount: this.items.length,
            orderno: data.kiosk_order_seq,
            balance: data.balance,
            billtotal: data.bill_total,
            paid: Number(data.bill_total) - Number(data.balance),
            kioskFcOrderIds: data.orders.flatMap((order) =>
              order.bill.balance > 0 ? order.order_id : []
            ),
          };        
        } else {
          this.items = data.items;
          this.amount = data.bill.fees;
          let name = data?.name?.split(' ') || [''];
          this.details = {
            name: name[0],
            ordercount: data.items.length,
            orderno: data.order_seq,
            balance: data.balance,
            billtotal: data.bill.bill_total,
            paid: data.bill.paid,
            balance_text: data.balance_text,
            billtotal_text: data.bill.bill_total_text,
            paid_text: data.bill.paid_text,
          };
        }
        this.grandTotal += +data.balance;

        let group = {
          items: this.items,
          amount: this.amount,
          details: this.details,
          orderid: orderid,
        };
        this.allDataList.push(group);
        if (this.isMergeBillFetchSuppressEnabled) {
          this.mergedOrderSyncEntries.set(
            String(orderid),
            this.buildMergeBillSyncEntry(orderid, data)
          );
          this.tryTriggerMergeBillSync();
        }
      });
  }
  printFinalBill() {
    let order_id = this.data.order_id;
    if (this.order_ids && this.order_ids.length > 0) {
      order_id = this.mergedOrderIds.join();
    }
    if (this.utilService.isPrinterEnabled()) {
      this.utilService.sendFinalPrintCommand(order_id, 1);
      // setTimeout(() => {
      //   this.dialogRef.close({ event: "close", api: true, ack: true });
      // }, 10);
    } else {
      this.getPrintDetails(1, '', 1);
    }
    this._eventTracker.easyeat_track_event('CASH_COLLECT_BILL_PRINT', {
      REQUEST_TAB: this._router.url.includes('orders')
        ? 'RUNNING ORDERS'
        : 'TABLE SERVICE',
    });
  }
  private validateKioskPrintRequirements(): boolean {
    return this.utilService.isPrinterEnabled() && this.kioskPrintOrderIds?.length > 0;
  }

  private canPrintKiosk(): boolean {
    return this.canTriggerKioskPrint;
  }

  private executePrintCommands(orderIds: string[]): void {
    this.utilService.sendFinalPrintCommand(orderIds[0]);
    orderIds.slice(1).forEach((orderId, index) => {
      setTimeout(() => {
        this.utilService.sendFinalPrintCommand(orderId);
      }, (index + 1) * 3000);
    });
  }

  private setPrintTimeout(orderIds: string[]): void {
    const totalDelay = orderIds?.length * 3000;
    this.kioskPrintTimeout = setTimeout(() => {
      this.canTriggerKioskPrint = true;
    }, totalDelay + 1000);
  }

  async printKioskBill() {
    if (!this.validateKioskPrintRequirements()) {
      this.message.showError(
        this.translationText.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER
      );
      return;
    }
    
    if (!this.canPrintKiosk()) return;
    
    try {
      this.canTriggerKioskPrint = false;
      const orderIds = this.kioskPrintOrderIds;
      this.executePrintCommands(orderIds);
      this.setPrintTimeout(orderIds);
    } catch (error) {
      console.error(error);
      this.canTriggerKioskPrint = true;
    }
  }

  printFinalBillHTML() {
    let finalBill = document.getElementById('finalBill');
    let WinPrint = window.open('', '', 'toolbar=1,scrollbars=1,status=0');
    WinPrint.document.write('<html><head><title>Print Order</title></head>');
    WinPrint.document.write('<html><head>');

    WinPrint.document.write('<title>Invoice</title>');
    WinPrint.document.write(
      '<style type="text/css">body{font-family: arial, sans-serif;font-size:14px;width:75mm}#finalBill{width:75mm}table{margin-top:20px; border-collapse: collapse;width: 100%;}table > tbody > tr > th{padding: 10px 3px; border-top: 1px solid rgba(0, 0, 0, 0.75); border-bottom: 1px solid rgba(0, 0, 0, 0.75) ;}.rest_details{text-align:center;font-size:12px,width:90%,margin-left:5%}.order_details{font-size:12px}.bold{font-weight:700}p{margin:0!important}#strid{background-color:red}.border-top{border-top:1px dashed #000}.width10{width:10%}.width15{width:15%}.width25{width:25%}.width50{width:50%}.button{font-size:18px;margin:10%;width:80%;background:green;border-radius:5px;color:#fff}table{margin-top:10px}.total-fee{text-align:right}</style>'
    );
    WinPrint.document.write('</head>');

    WinPrint.document.write('<body>');
    WinPrint.document.write(finalBill.innerHTML);
    WinPrint.document.write('</body></html>');
    WinPrint.document.close();

    if (this.isChrome()) {
      WinPrint.onload = function () {
        setTimeout(function () {
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        }, 200);
      };
    } else {
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
    // this.generateFinalBillJSON();
  }

  getPrintDetails(type, cid, itr) {
    const formData: any = new FormData();
    // formData.append("order_id", this.currentOrderId);
    formData.append('type', type);
    formData.append('counter_id', cid);
    formData.append('itr', parseInt(itr));
    if (this.order_ids.length < 1) {
      formData.append('order_id', this.data.order_id);
    } else {
      formData.append('order_id', this.mergedOrderIds.join());
    }
    this.apiService.getPrintDetail(formData).subscribe(
      (res: any) => {
        if (res.status == 1) {
          this.printData = res.data[0];
          setTimeout(() => {
            this.printFinalBillHTML();
            // this.dialogRef.close({ event: "close", api: true, ack: true });
          }, 10);
        } else {
          // this.dialogRef.close({ event: "close", api: true, ack: true });
        }
      },
      (_error) => {
        // this.dialogRef.close({ event: "close", api: true, ack: true });
      }
    );
  }
  isChrome() {
    return Boolean(window.chrome);
  }

  isNumber(val) {
    return typeof val === 'number';
  }
  paymentName(e) {
    this.currentPaymentMode = e;
  }

  paymentChannel(e) {
    this.currentPaymentChannel = e;
  }
  openDrawerOnDevice() {
    this.utilService.send_dkick_code_to_react(
      localStorage.getItem('dkick_code'),
      localStorage.getItem('restaurant_printer')
        ? localStorage.getItem('restaurant_printer')
        : 'Default Printer',
      this.orderid,
      ''
    );
    this.utilService.openCashDrawer();
  }
  transactionIdChange(e) {
    this.transcation_id = e;
  }
  cashTransactionDetail(e) {
    this.cashCollectedDetails = e;
  }
  isSliderDisabled(): boolean {
    if (this.currentPaymentChannel && this.grandTotal > 0) return false;
    else return true;
  }
  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.translationText[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
}
